export default `import hashlib
import hmac

API_KEY = "YOUR_API_KEY"

def generate_canny_hash(user_id):
    hash_obj = hmac.new(API_KEY.encode('utf-8'), user_id.encode('utf-8'), hashlib.sha256)
    return hash_obj.hexdigest()

# Example usage
user_id = "exampleUserID"
hash = generate_canny_hash(user_id)
print("Generated Hash:", hash)
`;
